export const colors = {
  "deep-purple": "#17072b",
  purple: "#9067c6",
  "light-purple": "#8d86c9",
  pink: "#cac4ce",
  "light-pink": "#f7ece1",
  "pink-two": "rgba(245,116,185,1)",
  blue: "rgba(89,97,223,1)"
}